/* global PROXY_AUTH_COOKIE_KEY */

import { cookie } from 'redux-effects-cookie'

const detectProxyIPCookie = async dispatch => ({ 'value': await dispatch(cookie(PROXY_AUTH_COOKIE_KEY))})

export {detectProxyIPCookie as default}
